<template>
    <div class="form enter-discount-open-value-popover">
        <div class="popover-body">
            <div v-if="props.discountType === DiscountType.Absolute">
                <CurrencyInput
                    :invalid="absoluteOpenValueInvalid"
                    :min="0.01"
                    style="width: 60%"
                    :maxFractionDigit="2"
                    :minFractionDigits="2"
                    v-model="absoluteOpenValue"
                />
            </div>
            <div v-if="props.discountType === DiscountType.Percentage">
                <CurrencyInput
                    :invalid="absoluteOpenValueInvalid"
                    :min="0.0001"
                    style="width: 60%"
                    :max="100"
                    :maxFractionDigits="4"
                    :minFractionDigits="4"
                    v-model="percentageOpenValue"
                />
            </div>
        </div>
        <VButton class="apply-btn primary rounded" @click="applyDiscountOpenValue">{{
            translations.general.apply
        }}</VButton>
    </div>
</template>

<script setup lang="ts">
    import { DiscountType } from "@/data/model/Enums";
    import { translations } from "@/shared/localization/translations";
    import { ref } from "vue";

    import CurrencyInput from "@/components/elements/CurrencyInput.vue";
    import VButton from "@/components/elements/VButton.vue";

    const props = defineProps<{
        hide?: () => void;
        onEnterValue: (value: number) => void;
        discountType: DiscountType;
    }>();

    const absoluteOpenValue = ref<number | null>(null);
    const percentageOpenValue = ref<number | null>(null);
    const absoluteOpenValueInvalid = ref<boolean>(false);
    const percentageOpenValueInvalid = ref<boolean>(false);

    function applyDiscountOpenValue(): void {
        switch (props.discountType) {
            case DiscountType.Absolute:
                absoluteOpenValueInvalid.value = false;
                if (absoluteOpenValue.value == null) {
                    absoluteOpenValueInvalid.value = true;
                } else {
                    props.onEnterValue(absoluteOpenValue.value!);
                    closePopover();
                }
                break;
            case DiscountType.Percentage:
                percentageOpenValueInvalid.value = false;
                if (percentageOpenValue.value == null) {
                    percentageOpenValueInvalid.value = true;
                } else {
                    props.onEnterValue(percentageOpenValue.value!);
                    closePopover();
                }
                break;
        }
    }

    function closePopover() {
        if (props.hide) props.hide();
    }
</script>

<style scoped lang="scss">
    .enter-discount-open-value-popover {
        .popover-body {
            margin: 28px 0;
            text-align: center;
        }

        > .apply-btn {
            height: 46px;
            font-size: 16px;
            font-weight: 300;
            width: 100%;
            border-radius: 23px !important;
            margin-bottom: 14px;
        }
    }
</style>
